import { Schema } from "rsuite";

const { StringType, ArrayType } = Schema.Types;

export const CompanyRegisterFormSchema = Schema.Model({
  CompanyName: StringType()
    .maxLength(60, "At most 60 characters")
    .isRequired("Company name is required"),
  Email: StringType()
    .maxLength(50, "At most 50 characters")
    .isEmail("Must be a valid email")
    .isRequired("Email is required"),
  AdminFirstName: StringType()
    .maxLength(30, "At most 30 characters")
    .isRequired(),
  AdminLastName: StringType()
    .maxLength(30, "At most 30 characters")
    .isRequired(),
  AdminEmail: StringType()
    .maxLength(50, "At most 50 characters")
    .isEmail("Must be a valid email")
    .isRequired(),
  ProviderNumber: StringType()
    .maxLength(50, "At most 50 characters")
    .isRequired(),
  AdminPhoneNumber: StringType()
    .maxLength(20, "At most 20 characters")
    .isRequired(),
  AdminPassword: StringType()
    .maxLength(20, "At most 20 characters")
    .isRequired()
    .minLength(6, "At least 6 characters"),
  AdminConfirmPassword: StringType()
    .maxLength(20, "At most 20 characters")
    .isRequired()
    .minLength(6, "At least 6 characters"),
  AdminUserName: StringType()
    .maxLength(20, "At most 20 characters")
    .isRequired("Admin Username is a required field")
    .minLength(6, "At least 6 characters"),
  InsuranceTypeIds: ArrayType()
    .minLength(1, "Select an Insurance Type")
    .isRequired("Insurance Type is required"),
});

export type CompanyRegisterRequestType = {
  CompanyName?: string;
  Email?: string;
  AdminFirstName?: string;
  AdminLastName?: string;
  AdminEmail?: string;
  AdminPhoneNumber?: string;
  AdminPassword?: string;
  AdminConfirmPassword?: string;
  AdminUserName?: string;
  ProviderNumber?: string;
  InsuranceTypeIds?: string[];
};
